export const PAGES = {
  PRIVATE_MESSAGES: '/private-messages',
};

export const MODALS = {
  BUG_REPORT: 'bug-report-modal',
  BUG_REPORT_SUCCESS: 'bug-report-success-modal',
};
